import clients from './clients.reducer';
import helpers from './helpers.reducer';
import listeners from './listeners.reducer';
import loaders from './loaders.reducer';
import session from './session.reducer';

export default {
  clients,
  helpers,
  listeners,
  loaders,
  session,
};
